import { PermissionsEnum } from "@/auth/interfaces";
import SavePuertosDisponiblesPage from "../../shared/savePuertosDisponibles/SavePuertosDisponiblesPage";
import { useCheckPermissions } from "@/shared";
import { Navigate, useParams } from "react-router-dom";
import { useGetnap } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";

export interface RevisarPuertosDisponiblesPageInterface {}

const RevisarPuertosDisponiblesPage: React.FC<RevisarPuertosDisponiblesPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_nap)
  const { id } = useParams();
  const { data, isLoading } = useGetnap(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_nap) return <Navigate to="/mantenimiento-operacion/naps" />;

  return <SavePuertosDisponiblesPage titlePage="Ver Puertos Disponibles" editNaps={data.data} />;
  // useCheckPermissions(PermissionsEnum.api_add_nap)
  // return <SavePuertosDisponiblesPage titlePage="Crear Naps" />;
};

export default RevisarPuertosDisponiblesPage;
